import React from "react";
import {ListComponent} from "../../components/ListComponent";
import {Loader} from "../../components/Loader";
import {TableFooter} from "../../components/ListComponent/TableFooter";
import {FormGroup} from "../../components/FormComponent/FormGroup";
import {DateTime} from "../../components/ListComponent/DateTime";
import {Util} from "../../components/Util";
import {RightAside} from "../../components/Aside/RightAside";
import {SignTurnRightFill} from "react-bootstrap-icons";
import {SysButton} from "../../components/Elements/SysButton";

export class InventoryStart extends ListComponent {
    protected location: string | null = null;
    protected inventoryId: number | null = null;
    protected actionInProgress: boolean = false;
    protected barcodeFocusActiveInput: string = 'form.x-form #barcode';

    constructor(props: {}) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.barcodeFocus = this.barcodeFocus.bind(this);
        this.closeInventory = this.closeInventory.bind(this);
        this.cancelInventory = this.cancelInventory.bind(this);
        this.setMultiplier = this.setMultiplier.bind(this);
        this.setMultiplierSubmit = this.setMultiplierSubmit.bind(this);
    }

    protected getRequestUrl(): RequestInfo | URL {
        if (this.inventoryId === null) {
            return `/inventory/start`;
        }
        if (this.location === null) {
            return `/inventory/init/${this.inventoryId}/`;
        }
        return `/inventory/add/${this.inventoryId}`;
    }

    renderInventoryStart() {
        if (!this.state) {
            return <Loader/>;
        }
        return (<>
            <div className="row">
                <h5 className="open-search">{this.dictionary.get['initialization']}</h5>
                <form className="x-form" method="POST" onSubmit={this.handleSubmit} id={'renderInventoryStart'}></form>
            </div>
        </>);
    }

    handleSubmit(event: any) {
        if (document.querySelector('#multiplier-suffix')) {
            const multiplierSuffix = document.querySelector('#multiplier-suffix') as HTMLElement;
            multiplierSuffix.innerText = '1x';
        }

        super.handleSubmit(event);

        if (document.querySelector('#multiplier-suffix')) {
            this.barcodeFocusActiveInput = 'form.x-form #barcode';
            this.barcodeFocus();
        }
    }

    renderLocationInit() {
        if (!this.state) {
            return <Loader/>;
        }

        setTimeout(() => {
            const barcode = document.querySelector('form.x-form #barcode') as HTMLInputElement | null;
            if (barcode && !this.actionInProgress) {
                barcode.value = '';
                barcode.focus();
            }
        }, 200);

        return (<>
                <div className="row">
                    <h5 className="open-search">{this.dictionary.get['location']}</h5>
                    <form className="x-form" method="POST" onSubmit={this.handleSubmit} id={'renderLocationInit'}>

                        {this.location && <div className="row">
                            <div className="col-12 caption details">
                                <button className="btn btn-sm btn-warning float-end" onClick={this.cancelInventory}
                                        type={'button'}>
                                    {this.capitalizeFirstLetter(this.dictionary.get['cancel-inventory'])}
                                </button>
                                <button className="btn btn-sm btn-primary float-end" onClick={this.closeInventory}
                                        type={'button'}>
                                    {this.capitalizeFirstLetter(this.dictionary.get['close-inventory'])}
                                </button>
                            </div>
                        </div>}

                        <div className="row">
                            <div className="col-md-12 col-lg-6 col-xl-4">
                                <FormGroup.Input {...{
                                    id: 'barcode',
                                    placeholder: this.dictionary.get['location'],
                                    autoFocus: true,
                                    skipLabel: true,
                                    autoComplete: 'off',
                                    defaultValue: '',
                                    required: true,
                                    onBlur: this.barcodeFocus
                                }}/>
                                {this.state.error &&
                                    <p className={'alert alert-danger'}>{this.dictionary.translate(this.state.error)}</p>}
                            </div>
                            <div className="col-md-12 col-lg-6 col-xl-4">
                                <button className="btn btn-sm btn-primary" type="submit">
                                    {this.dictionary.get['submit']}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
                {this.listOfItems()}
            </>
        );
    }

    private closeInventory(e: any) {
        e.preventDefault();
        this.actionInProgress = true;

        this.request.fetch(`/inventory/close/${this.inventoryId}`, null, {method: 'POST'}).catch(error => {
            this.onError(error);
            console.error(error);
            // @ts-ignore
            return this.request.response.json();
        }).then(e => {
            window.location.assign('/inventory/exec')
        });
    }

    private cancelInventory(e: any) {
        e.preventDefault();
        this.actionInProgress = true;

        this.request.fetch(`/inventory/cancel/${this.inventoryId}`, null, {method: 'POST'}).catch(error => {
            this.onError(error);
            console.error(error);
            // @ts-ignore
            return this.request.response.json();
        }).then(e => {
            window.location.assign('/inventory/exec')
        });
    }

    capitalizeFirstLetter(val: string) {
        return String(val).charAt(0).toUpperCase() + String(val).slice(1);
    }

    addProductInit() {
        if (!this.state) {
            return <Loader/>;
        }
        const actionInProgress = this.actionInProgress;
        setTimeout(() => {
            const barcode = document.querySelector('form.x-form #barcode') as HTMLInputElement | null;
            if (barcode && !actionInProgress) {
                barcode.value = '';
                barcode.focus();
            }
        }, 200);

        return (<>
                <div className="row">
                    <h5 className="open-search">
                        {this.dictionary.get['add-product']} - {this.location}
                    </h5>
                    <form className="x-form" method="POST" onSubmit={this.handleSubmit}>
                        <div className="row">
                            <div className="col-12 caption details">
                                <button className="btn btn-sm btn-warning float-end" onClick={this.cancelInventory}
                                        style={{marginRight: 0}}
                                        type={'button'}>
                                    {this.capitalizeFirstLetter(this.dictionary.get['cancel-inventory'])}
                                </button>
                                <button className="btn btn-sm btn-primary float-end" onClick={this.closeInventory}
                                        type={'button'}>
                                    {this.capitalizeFirstLetter(this.dictionary.get['close-inventory'])}
                                </button>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 col-lg-6 col-xl-4">
                                <div className={'input-group input-group-sm'} style={{marginBottom: '10px'}}>
                                    <input {...{
                                        id: 'barcode',
                                        name: 'barcode',
                                        className: 'form-control form-control-sm',
                                        placeholder: this.dictionary.get['set-barcode'],
                                        autoFocus: true,
                                        autoComplete: 'off',
                                        required: true,
                                        defaultValue: '',
                                        onBlur: this.barcodeFocus,
                                    }}/>
                                    <span className={'input-group-text'} onClick={this.setMultiplier} style={{
                                        color: 'rgb(255, 255, 255)',
                                        backgroundColor: 'rgb(13, 110, 253)',
                                        cursor: 'pointer',
                                        fontWeight: 'bold'
                                    }}
                                    >&nbsp;<span id={'multiplier-suffix'}>1x</span>&nbsp;</span>
                                </div>
                                <input type={'hidden'} name={'multiplier'} id={'multiplier-input'} value={1}/>
                                {this.state.error &&
                                    <p className={'alert alert-danger'}>{this.dictionary.translate(this.state.error)}</p>}
                            </div>
                            <div className="col-md-12 col-lg-6 col-xl-4">
                                <button className="btn btn-sm btn-primary" type="submit" style={{marginBottom: '10px'}}>
                                    {this.dictionary.get['submit']}
                                </button>
                            </div>
                        </div>
                        <input type={'hidden'} name={'locationBarcode'} id={'locationBarcode'}
                               value={this.location || ''}/>
                    </form>
                </div>
                <div className="hidden">
                    <form onSubmit={this.setMultiplierSubmit} action={'#'} method="PATCH" id="set-multiplier"
                          className="hidden details">

                        <h6>
                            {this.dictionary.get['set-multiplier']}
                            <SignTurnRightFill className="closeRightAside" onClick={this.rightAsideClose}/>
                        </h6>

                        <div style={{marginTop: '40px', marginBottom: '30px'}}>
                            <FormGroup.Input {...{
                                id: 'multiplier-value',
                                type: 'number',
                                placeholder: this.dictionary.get['multiplier'],
                                autoFocus: true,
                                autoComplete: 'off',
                                defaultValue: ''
                            }}/>
                        </div>

                        <div className="form-group">
                            <button type="submit" className="btn btn-sm btn-success">
                                {this.dictionary.get['save']}
                            </button>
                            <SysButton className="closeRightAside" type={'SignTurnRightFill'}
                                       text={this.dictionary.get['close']} onClick={this.rightAsideClose}/>
                        </div>
                    </form>
                </div>
                {this.listOfItems()}
            </>
        );
    }

    private rightAsideClose(): void {
        this.barcodeFocusActiveInput = 'form.x-form #barcode';
        RightAside.close();
        this.barcodeFocus();
    }

    private setMultiplier(e: any): void {
        e.preventDefault();
        this.barcodeFocusActiveInput = '#multiplier-value';
        (document.querySelector('#multiplier-value') as HTMLInputElement).value = '';

        RightAside.open(document.querySelector('#set-multiplier') as HTMLElement);
    }

    protected setMultiplierSubmit(event: any) {
        event.preventDefault();

        const multiplierValue: string = (document.querySelector('#multiplier-value') as HTMLInputElement).value || '1';

        const multiplierInput = document.querySelector('#multiplier-input') as HTMLInputElement;
        const multiplierSuffix = document.querySelector('#multiplier-suffix') as HTMLElement;

        multiplierSuffix.innerText = multiplierValue + 'x';
        multiplierInput.value = multiplierValue;

        this.rightAsideClose();
    }

    listOfItems() {
        if (!this.state?.item?.items || !this.location) {
            return ('');
        }
        return (<>
            <div className="row">
                <div className="table-responsive">
                    <table className="table table-hover table-sm align-middle">
                        <thead>
                        <tr>
                            <th className="sortable" data-sortkey="i.id">
                                #ID
                            </th>
                            <th className="sortable" data-sortkey="i.sku">
                                {this.dictionary.get['sku']}
                            </th>
                            <th className="sortable" data-sortkey="p.`name`">
                                {this.dictionary.get['product_name']}
                            </th>
                            <th className="sortable" data-sortkey="i.quantity">
                                {this.dictionary.get['quantity']}
                            </th>
                            <th className="sortable" data-sortkey="i.updated_at">
                                {this.dictionary.get['updated_at']}<i className="bi bi-sort-down"></i>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.state.item.items.map(function (elem: any) {
                            return (
                                <tr key={elem.id + '-sku:' + elem.sku} data-id={elem.id}>
                                    <td align={'right'}>{elem.id}.</td>
                                    {Util.searchCell(elem.sku || '', 'barcode', {}, false)}
                                    <td>{elem.product_name}</td>
                                    <td>{elem.quantity}</td>
                                    <td><DateTime value={elem.updated_at} inline={true}/></td>
                                </tr>
                            )
                        })}
                        </tbody>
                        {/*{this.state.itemsCount < this.limit ? (*/}
                        <TableFooter colspan={6}/>
                        {/*) : ''}*/}
                    </table>
                    {/*{this.state.isLoading && <Loader/>}*/}
                </div>
            </div>
        </>);
    }

    render() {
        if (!this.state) {
            return <Loader/>;
        }
        if (this.state?.item?.id) {
            this.inventoryId = this.state.item.id;
        }
        if (this.state?.item?.location) {
            this.location = this.state.item.location;
        }

        if (this.inventoryId === null) {
            return this.renderInventoryStart();
        }
        if (this.location === null) {
            return this.renderLocationInit();
        }

        return this.addProductInit();
    }

    private barcodeFocus() {
        const actionInProgress = this.actionInProgress;

        setTimeout(() => {
            let actionInput: HTMLInputElement | null = document.querySelector(this.barcodeFocusActiveInput) as HTMLInputElement;
            if (actionInput && !actionInProgress) {
                actionInput.focus();
            }
        }, 250);
    }
}
